import './index.css'

import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { Outlet } from 'react-router-dom'

import mixpanel from '@disco/api/mixpanel'
import { PLAN_ACTIVE } from '@disco/constants/FeatureTypes'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { toggleSidebar } from '@disco/state-management/actions/AppActions'
import { isDeviceTypePhone } from '@disco/state-management/selectors/app'
import { getFeatureData } from '@disco/state-management/selectors/business'
import {
  getNumberOfUsers,
  getUser,
} from '@disco/state-management/selectors/user'

import type { User } from 'types/user'

import Pricing2021 from 'components/common/pricing2021'

// TODO: This is a page/route placeholder for now.
// Only show this page when DISCO-7352 and all children tasks are DONE
function mapStateToProps(state) {
  const { isFeatureEnabled: activePlan, isTrial } = getFeatureData(state, {
    featureName: PLAN_ACTIVE,
  })
  const user = getUser(state)
  return {
    deprecatedPlan: !activePlan,
    isTrial,
    maxFilesCurrentPlan: user.business.stats.total_track_count,
    maxUsersCurrentPlan: getNumberOfUsers(state),
    userData: user,
    sidebarOpen: state.app.sidebarOpen,
    planUpdateLoad: state.user.planUpdateLoad,
    isPhone: isDeviceTypePhone(state),
  }
}

const actions = {
  sendMixpanelEvent,
  toggleSidebar,
}
type Props = typeof actions & {
  children: React.ReactNode
  deprecatedPlan: boolean
  isTrial: boolean
  maxFilesCurrentPlan: number
  maxUsersCurrentPlan: number
  sendMixpanelEvent: (...args: Array<any>) => any
  userData: User
  sidebarOpen: boolean
  planUpdateLoad: boolean
  isPhone: boolean
}

const BillingPlans = (props: Props): React.ReactNode => {
  const {
    deprecatedPlan,
    isTrial,
    userData,
    maxUsersCurrentPlan,
    maxFilesCurrentPlan,
    children,
  } = props
  const billingRef = useRef(null)
  useEffect(() => {
    mixpanel.startSessionRecording(true)
  }, [])
  const pricing2021Props: React.ComponentProps<typeof Pricing2021> = {
    deprecatedPlan: deprecatedPlan,
    maxFilesCurrentPlan,
    maxUsersCurrentPlan,
    billingRef: billingRef,
    rootPath: '/settings/billing/plans',
  }
  return (
    <>
      <div className="Billing_Pricing2021Container">
        <div className="Billing_Pricing2021FlexWrapper" ref={billingRef}>
          <Pricing2021 {...pricing2021Props} isPlanChange />
        </div>
      </div>
      {children}
      <Outlet />
    </>
  )
}

export default connect(mapStateToProps, actions)(BillingPlans) as any
